<template>
    <div>
        <PopForm :state="state" width="990px" body-max-height="670px">
            <template v-slot:title>确认</template>
            <div class="body">
                <!--搜索会员-->
                <div class="search-user-box">
                    <search-user @searched="userSearched" ref="searchDom"></search-user>&nbsp;&nbsp;
                    <el-button @click="clearUser">清除会员</el-button>
                </div>

                <!--会员信息-->
                <el-collapse-transition>
                    <div class="user-info-box" v-show="userInfo.store_uid">
                        <user-info :user-info="userInfo" @update="userInfoUpload"></user-info>
                    </div>
                </el-collapse-transition>

                <!--结算项目-->
                <div class="product-box">
                    <cash-total-product :content="tableData" :user-info="userInfo" @updateProductList="setTotalPrice"
                                        @resetTotalPrice="updateDiscountData" :dis-model="disModel"
                                        @discountChange="discountChange" />
                </div>

            </div>
            <!--积分抵扣-->
            <div class="score-box">
                <cash-use-score v-model="scoreData" :total-price="allTotalPrice" :store-uid="userInfo.store_uid"
                                @scoreChange="scoreChangeEvent"
                />
            </div>
            <!--结算统计-->
            <div class="total-count">
                <div class="item">
                    <div class="label">应付</div>
                    <div class="data price">¥{{payablePrice}}</div>
                </div>
                <div class="item">
                    <div class="label">实收</div>
                    <div class="data">
                        <el-input class="input-width" v-model="actualMoney" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">付款方式</div>
                    <div class="data">
                        <el-select class="input-width" v-model="payType.value" placeholder="请选择">
                            <el-option
                                    v-for="item in payType.options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <template v-slot:foot>
                <div class="foot">
                    <div class="attach-box">
                        <el-button-group>
                            <el-button size="mini" @click="giveState = true">赠送</el-button>
                            <el-button size="mini" @click="remarkState = true">备注</el-button>
                        </el-button-group>
                    </div>
                    <div class="btn-box">
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="orderPayBefore">确定结算</el-button>
                    </div>
                </div>
            </template>
        </PopForm>

        <!--收银结束-->
        <cash-pay-done v-model="payDoneState" @printEvent="printState = true" :over-data="overData"
                       @settleOver="settleOver" />
        <!--输入密码-->
        <cash-input-password v-model="showPasswordInput" @passwordChange="passwordChangeEvent" />
        <!--小票打印-->
        <ticket-print v-model="printState" :ticket-data="ticketData"></ticket-print>
        <!--赠送模块-->
        <cash-give v-model="giveState" :init-data="giveData" @submit="setGiveData" />
        <!--备注-->
        <cash-remark v-model="remarkState" :init-data="remarkData" @submit="setRemarkData" />
        <!--组合付款-->
        <cash-joint-pay v-model="jointPayState" :actual-price="actualMoney" :user-info="userInfo"
                        :pay-data="jointPay" @submit="jointPayChange" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import CashDiscount from "@/js/object/CashDiscount";
    import SearchUser from "@/model/Cash/SearchUser";
    import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";
    import UserInfo from "@/model/Cash/UserInfo";
    import CashTotalProduct from "@/model/Cash/CashTotalProduct";
    import CashInputPassword from "@/model/Cash/CashInputPassword";
    import TicketPrint from "@/model/Cash/TicketPrint";
    import CashPayDone from "@/model/Cash/CashPayDone";
    import CashGive from "@/model/Cash/CashGive";
    import CashRemark from "@/model/Cash/CashRemark";
    import CashUseScore from "@/model/Cash/CashUseScore";
    import CashJointPay from "@/model/Cash/CashJointPay";
    import PopForm from "@/model/PopForm";
    export default {
        name: "CashTotalBox",
        components: {
            PopForm,
            CashJointPay,
            CashUseScore,
            CashRemark,
            CashGive,
            CashPayDone,
            TicketPrint, CashInputPassword, CashTotalProduct, UserInfo, ElCollapseTransition, SearchUser},
        model: {
            prop: "state",
            event: "show",
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            orderList: Array,
        },
        data: () => ({
            loading: false,
            tableData: [],
            userInfo: {},   //用户信息

            showPasswordInput: false,   //显示密码输入框
            password: "",           //用户支付密码

            allTotalPrice: 0,  //合计金额
            payablePrice: "0.00",    //抵扣后的金额
            actualMoney: "0.00",    //实收金额
            payType: {              //付款方式
                value: "",
                options: [
                    { label: "余额", value: 1},
                    { label: "微信", value: 2},
                    { label: "支付宝", value: 3},
                    { label: "现金", value: 4},
                    { label: "银联卡", value: 5},
                    { label: "欠款", value: 7},
                    { label: "组合支付", value: 6}
                ]
            },

            //小票
            printState: false,
            ticketData: [],

            //赠送模块开关
            giveState: false,
            giveData: {},

            //备注
            remarkState: false,
            remarkData: "",

            //结算结束框
            payDoneState: false,
            overData: {
                totalPayMoney: "0.00",  //支付金额
                storeUserMoney: "",     //会员余额
            },

            //折扣
            disModel: null,

            //使用积分
            scoreData: {
                score: 0,
                deductPrice: 0,
            },

            //组合支付
            jointPayState: false,
            jointPay: {}
        }),
        mounted: function () {
            this.syncTableData();
            this.disModel = CashDiscount;
        },
        methods: {
            //初始化数据
            initData: function () {
                this.userInfo = {};
                this.giveData = {};
                this.payType.value = "";
                CashDiscount.init();
            },
            //同步订单数据
            syncTableData: function () {
                this.tableData = obj.copyObject(this.orderList);
                if(!obj.isEmpty(this.userInfo)) {
                    this.updateTableUserInfo();
                }else
                    this.setTotalPrice();
            },
            //关闭
            close: function () {
                this.$emit("show", false);
            },
            //搜索会员结果
            userSearched: function (userInfo) {
                this.userInfo = userInfo;
                CashDiscount.setUserInfo(userInfo);
            },
            //用户信息更新
            userInfoUpload: function (userInfo) {
                if(!obj.isEmpty(userInfo))
                    this.userInfo.money = userInfo.money;

                this.scoreData = {
                    score: 0,
                    deductPrice: 0,
                };
            },
            //清除会员
            clearUser: function () {
                this.userInfo = {};
                CashDiscount.clearStoreUser();
                if(this.$refs.searchDom)
                    this.$refs.searchDom.clearSearchValue();
            },
            //输入密码
            passwordChangeEvent: function (pwd) {
                if(this.loading) return false;
                this.loading = true;

                this.password = pwd;
                this.settleEvent();
            },
            //收银结束
            settleOver: function () {
                //清除会员信息
                this.clearUser();
                //已结算订单key;
                let orderIdArr = [];
                this.tableData.forEach(item => {
                    orderIdArr.push(item.order_key);
                });
                this.$emit("settleOver", orderIdArr);
            },
            //付款前检查
            orderPayBefore: function () {
                //检查实收是否合法
                let actPrice = Number(this.actualMoney);
                if(isNaN(actPrice) || actPrice < 0) {
                    obj.message.error("实收金额错误");
                    return false;
                }

                //检查付款方式
                if(this.payType.value === "") {
                    obj.message.error("请选择付款方式");
                } else if(this.payType.value === 6) {
                    this.jointPayState = true;
                }else{
                    this.checkOrderNoAndSettle();
                }
            },
            //组合支付改变
            jointPayChange: function (payData) {
                this.jointPay = payData;
                this.checkOrderNoAndSettle();
            },
            //检查订单单号是否重复
            checkOrderNoAndSettle: function () {
                if(this.loading) return false;
                this.loading = true;

                let orderNoArr = [];
                let repeatNo = "";
                this.tableData.forEach(item => {
                    if(item.order_no) {
                        if (orderNoArr.indexOf(item.order_no) > -1)
                            repeatNo = item.order_no;

                        orderNoArr.push(item.order_no);
                    }
                });

                //结算订单中是否有单号相同
                if(repeatNo !== ""){
                    obj.message.error(repeatNo+"单号重复，请检查");
                    this.loading = false;
                    return false;
                }

                //检查订单、挂单中订单号是否存在
                if(orderNoArr.length > 0) {
                    let orderNoSplit = orderNoArr.join(",");
                    obj.postData("cash/check_order_no", {
                        order_no: orderNoSplit,
                    }, res => {
                        if (res.errcode === 0) {
                            //结算
                            this.settleEvent();
                        } else {
                            this.loading = false;
                            obj.message.error(res.errdesc);
                        }
                    }, res => {
                        this.loading = false;
                    });
                }else{
                    this.settleEvent();
                }
            },
            //结算
            settleEvent: function () {
                let userInfo = null;
                if(!obj.isEmpty(this.userInfo)){
                    userInfo = {
                        store_uid: this.userInfo.store_uid,
                        password: this.password
                    };
                    this.password = "";
                }

                let orderList = [];
                this.tableData.forEach(item => {
                    let order = {
                        tmp_id: item.tmp_id ? item.tmp_id : "",
                        order_no: item.order_no ? item.order_no : "",
                        order_date: item.order_date ? item.order_date : "",
                        pro_data: []
                    };
                    item.pro_list.forEach(val => {
                        order.pro_data.push({
                            pro_type: val.pro_type,
                            pro_id: val.pro_id,
                            price: val.price,
                            num: val.num,
                            discount: val.discount,
                            discount_type: val.discount_type ? val.discount_type : 0,
                            discount_data: val.discount_data,
                            total_price: val.total_price,
                            staff: val.staff
                        });
                    });
                    orderList.push(order);
                });

                //如果是组合支付，检查付款情况
                let jointPayData = {};
                let payUserMoney = 0;   //余额支付金额
                let arrearsMoney = 0;   //欠款金额
                if(this.payType.value === 6) {
                    payUserMoney = parseFloat(this.jointPay.money);
                    arrearsMoney = parseFloat(this.jointPay.arrears);
                    let surPrice =  this.actualMoney - this.jointPay.money - this.jointPay.wechat - this.jointPay.alipay -
                        this.jointPay.cash - this.jointPay.unionpay - this.jointPay.arrears;
                    surPrice = Math.round(surPrice * 100)/100;
                    if(surPrice !== 0) {
                        // this.$message.error("组合支付金额与实收金额不符，请确认");
                        this.jointPayState = true;
                        this.loading = false;
                        return false;
                    }else{
                        jointPayData = this.jointPay;
                    }
                }else if(this.payType.value === 1){
                    payUserMoney = this.actualMoney ? parseFloat(this.actualMoney) : 0;
                }else if(this.payType.value === 7){
                    arrearsMoney = this.actualMoney ? parseFloat(this.actualMoney) : 0;
                }

                let postData = {
                    user_info: userInfo ? userInfo : "",
                    total_price: this.allTotalPrice ? this.allTotalPrice : 0,
                    score_deduct: this.scoreData.score,
                    score_deduct_price: this.scoreData.deductPrice,
                    actual_money: this.actualMoney ? this.actualMoney : 0,
                    pay_type: this.payType.value ? this.payType.value : 0,
                    joint_pay_data: JSON.stringify(jointPayData),
                    order_list: orderList,
                    give_data: this.giveData,
                    remark: this.remarkData,
                };

                if(payUserMoney > 0 && postData.user_info){
                    if(obj.isEmpty(postData.user_info.store_uid)) {
                        obj.message.error("请选择会员");
                        this.loading = false;
                        return false;

                    }else if(parseFloat(this.userInfo.money) < payUserMoney){
                        //会员余额不足
                        obj.message.error("会员余额不足");
                        this.loading = false;
                        return false;

                    }else if(obj.isEmpty(postData.user_info.password) && this.userInfo.pay_password){
                        //输入密码
                        this.showPasswordInput = true;
                        this.loading = false;
                        return false;
                    }
                }else if( (payUserMoney > 0 || arrearsMoney > 0) && obj.isEmpty(postData.user_info.store_uid) ){
                    obj.message.error("请选择会员");
                    this.loading = false;
                    return false;
                }

                obj.postData("cash/settle_more", {settle_data: JSON.stringify(postData)}, res => {
                    if(res.errcode === 0){
                        this.overData = {
                            storeUserMoney: res.store_user_money,
                            totalPayMoney: postData.actual_money,
                        };
                        this.ticketData = res.ticket_data;
                        this.payDoneState = true;
                        this.$emit("show", false);
                    }else{
                        obj.message.error(res.errdesc);
                    }
                    this.loading = false;
                }, res => {
                    this.loading = false;
                });
            },
            //计算总价
            setTotalPrice: function () {
                if(this.tableData.length > 0) {
                    let totalPrice = 0;
                    this.tableData.forEach(item => {
                        item.pro_list.forEach(data => {
                            totalPrice += parseFloat(data.total_price);
                        });
                    });

                    this.allTotalPrice = totalPrice;
                    this.payablePrice = totalPrice.toFixed(2);
                    this.actualMoney = totalPrice.toFixed(2);
                } else {
                    this.allTotalPrice = 0;
                    this.payablePrice = "0.00";
                    this.actualMoney = "0.00";
                }
            },

            /**
             * 优惠改变
             */
            discountChange: function (params) {
                this.updateDiscountData(params.item, params.discountIndex);
            },

            //同步会员信息
            updateTableUserInfo: function () {
                this.jointPay = {}; //重置组合支付

                this.tableData.forEach(data => {
                    // data.user_info = this.userInfo;
                    data.pro_list.forEach( item => {
                        item.discount_index = null;
                        this.updateDiscountData(item);
                    });
                });
            },

            //更新折扣优惠
            updateDiscountData: function (item, index = null) {
                if(obj.isEmpty(this.userInfo)) {
                    item.discount = "无";
                    item.discount_type = 0;
                    item.discount_data = {};
                    item.all_discount = null;
                    this.totalProPrice(item);
                }else {
                    CashDiscount.updateDiscount(item, index).then( () => {
                        this.totalProPrice(item);
                    });
                }
            },
            //计算项目价格
            totalProPrice: function (item) {
                CashDiscount.totalProPrice(item);
                this.flushOrderData();
            },
            //刷新数据
            flushOrderData: function () {
                this.tableData = [...this.tableData];
                this.setTotalPrice();
            },
            //设置赠送数据
            setGiveData: function (giveData) {
                this.giveData = giveData;
            },
            //设置备注信息
            setRemarkData: function (remark) {
                this.remarkData = remark;
            },
            //积分抵扣改变
            scoreChangeEvent: function (scoreData) {
                this.payablePrice = (this.allTotalPrice - scoreData.deductPrice).toFixed(2);
                this.actualMoney = this.payablePrice;
            },
        },
        watch: {
            "orderList": function () {
                this.syncTableData();
            },
            "userInfo": function (newInfo) {
                this.updateTableUserInfo();
            },
            "state": function (data) {
                if(!data)
                    this.initData();
            },
            loading: function (val) {
                if(val){
                    this.loadDom = this.$loading({
                        lock: false,
                        // text: 'Loading',
                        // spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)',
                        target: ".container"
                    });
                }else{
                    this.loadDom.close();
                }
            }
        }
    }
</script>

<style scoped>
    .search-user-box{
        padding: 6px 16px 0;
    }
    .user-info-box{
        padding: 16px 16px 0;
    }
    .product-box{
        padding: 16px 16px 0;
        flex: 1;
        display: flex;
        overflow: auto;
    }
    .total-count{
        padding: 20px 16px 0 20px;
        overflow: hidden;
    }
    .total-count>.item{
        display: inline-block;
        margin-right: 20px;
    }
    .total-count>.item>.label{
        display: inline-block;
    }
    .total-count>.item>.data{
        display: inline-block;
        margin-left: 10px;
    }
    .total-count>.item>.data .input-width{
        width: 180px;
    }
    .body{
        height: 440px;
        display: flex;
        flex-flow: column nowrap;
    }
    .body .el-table{
        padding: 0px 16px 16px;
    }
    .body .el-table, .body .el-table:before{
        background-color: transparent;
        border: none;
    }
    .foot{
        padding: 0 20px 10px;
        display: flex;
        align-items: center;
    }
    .attach-box{
        flex: 1;
        text-align: left;
    }
    .btn-box{
        flex: 1;
        text-align: right;
    }
    .price{
        color: red;
        font-size: 28px;
        font-weight: bold;
    }
    .score-box{
        padding-left: 16px;
        padding-right: 16px;
    }
</style>
